module.exports = __webpack_public_path__ + "img/instagram.8897a007.png";